// Logo
import Logo from '../../assets/logo.svg'
// Icons
import ArrowIcon from '../../assets/icons/arrow.svg'
// Logos
import LogoMercadoPago from '../../assets/payments/mp.svg'
import LogoMasterCard from '../../assets/payments/mastercard.png'
import LogoVisa from '../../assets/payments/visa.png'
import LogoAmerican from '../../assets/payments/american-express.png'
import LogoNaranja from '../../assets/payments/naranja.png'
import LogoCabal from '../../assets/payments/cabal.png'
import LogoMaestro from '../../assets/payments/maestro.png'
import LogoDiners from '../../assets/payments/diners-club.png'
import LogoNativa from '../../assets/payments/nativa.png'
import LogoArgencard from '../../assets/payments/argencard.png'
import LogoPagoFacil from '../../assets/payments/pagofacil.png'
import LogoRapiPago from '../../assets/payments/rapipago.png'
import LogoTransferencia from '../../assets/payments/deposito.png'

export const images = {
  Logo,
  ArrowIcon,
  LogoMercadoPago,
  LogoMasterCard,
  LogoVisa,
  LogoAmerican,
  LogoNaranja,
  LogoCabal,
  LogoMaestro,
  LogoDiners,
  LogoNativa,
  LogoArgencard,
  LogoPagoFacil,
  LogoRapiPago,
  LogoTransferencia
}
